export default {
  noData: {
    id: 'dashboard_others_list_no_data',
    defaultMessage: 'No data',
  },
}
